export default "__VITE_ASSET__BqzQOG_W__"